module.exports = __webpack_public_path__ + "static/media/img_create_password.1170d6e9.svg";